/*
  WKS custom: houdt de Microsoft brand agent ingeklapt.

  De agent komt van de app embed "Microsoft Clarity / brandAgents_js" en klapt
  uit zichzelf open met suggesties (nudges). Dit script houdt alleen het ronde
  icoon zichtbaar. Klikken op het icoon opent de chat gewoon volledig.

  Twee lagen, zodat het ook standhoudt als Microsoft de opmaak wijzigt:
  1. CSS in de shadow DOM van de widget (verbergt de nudge-tekst)
  2. een vormcontrole: is de knop breder dan hoog, dan gaan de delen zonder het
     ronde icoon op verborgen

  Terugdraaien: verwijder dit bestand plus het script-tag in layout/theme.liquid.
  Aangezet op 26 augustus 2026.
*/
(function () {
  var STYLE_ID = 'wks-agent-quiet';
  var CSS =
    '[data-testid="entrypoint"] .entrypoint-shimmer-text{display:none !important}' +
    '[data-testid="entrypoint"] div:has(> .entrypoint-shimmer-text){display:none !important}' +
    '[data-testid="entrypoint"] button[aria-label="Dismiss"]{display:none !important}' +
    '[data-testid="entrypoint"] .entrypoint-shadow + div{width:0px !important;opacity:0 !important;margin:0 !important;pointer-events:none !important}';

  var cached = null;

  function findRoot() {
    if (cached && cached.querySelector('[data-testid="entrypoint"]')) return cached;
    cached = null;
    var stack = [document];
    while (stack.length) {
      var root = stack.pop();
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) {
        var sr = all[i].shadowRoot;
        if (!sr) continue;
        if (sr.querySelector('[data-testid="entrypoint"]')) { cached = sr; return cached; }
        stack.push(sr);
      }
    }
    return null;
  }

  function tidy() {
    var root = findRoot();
    if (!root) return;

    if (!root.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      root.appendChild(style);
    }

    // chatvenster open? dan niets aanraken
    if (root.querySelector('textarea, input')) return;

    var ep = root.querySelector('[data-testid="entrypoint"]');
    var avatar = root.querySelector('.agent-avatar-bg') || root.querySelector('[data-testid="entrypoint"] svg');
    if (!ep || !avatar) return;

    var box = ep.getBoundingClientRect();
    if (box.width <= box.height * 1.4) return;

    var parts = ep.querySelectorAll('div, span, p, button');
    for (var i = 0; i < parts.length; i++) {
      var el = parts[i];
      if (el === avatar || el.contains(avatar) || avatar.contains(el)) continue;
      el.style.setProperty('display', 'none', 'important');
    }
  }

  var pending = null;
  function schedule() {
    if (pending) return;
    pending = setTimeout(function () { pending = null; tidy(); }, 150);
  }

  tidy();
  setInterval(tidy, 700);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
